// @ts-strict-ignore
import type { Schema } from '@empathyco/x-adapter'
import type { HierarchicalFilter } from '@empathyco/x-types'

export const hierarchicalFilterSchema: Schema<any, HierarchicalFilter> = {
  modelName: () => 'HierarchicalFilter',
  id: 'filter',
  facetId: (_, { facetId }: { facetId: string }) => facetId,
  parentId: (_, { parentId }: { parentId: string | null }) => parentId ?? null,
  label: 'value',
  totalResults: 'count',
  selected: () => false,
  children: {
    $path: 'children',
    $subSchema: '$self',
    $context: { parentId: 'filter' },
  },
}
